module.exports = __webpack_public_path__ + "static/media/ic-doc-pdf.d39a77db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-doc-pdf.svg
// module id = 622
// module chunks = 14